import {useState, useRef, useEffect} from "react";
import {FaArrowLeft} from "react-icons/fa";
import {HiPlus} from "react-icons/hi";
import {ImSpinner} from "react-icons/im";
import {FaCheck} from "react-icons/fa6";
import {FaCamera} from "react-icons/fa";
import ProfileService from "../../../../services/Profile";
import FileService from "../../../../services/File";
import {BsGiftFill} from "react-icons/bs";
import {useNavigate} from "react-router-dom";
import LoginService from "../../../../services/Login";
import Url from "../../../../url/Url";

export default function CompleteProfile() {
    const Navigate = useNavigate();
    const [user, setUser] = useState();

    const [formData, setFormData] = useState({
        fullName: "",
        phone: "",
        email: "",
        birthDate: "",
        biography: "",
        mobile: ""
    });


    const [progress, setProgress] = useState(0);
    const [isUploadingImage, setIsUploadingImage] = useState(false);
    const [profileImage, setProfileImage] = useState();
    const [isSaving, setIsSaving] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [focusedField, setFocusedField] = useState(null);
    // const [referralOpen, setReferralOpen] = useState(false)
    const [referralCode, setReferralCode] = useState("");
    const [referralLoading, setReferralLoading] = useState(false);

    const fileInputRef = useRef(null);
    const profilePictureRef = useRef(null);

    async function getProfile() {
        try {
            const res = await ProfileService.getProfile();
            setUser(res.data?.data?.finduser);
        } catch (err222) {
            console.error("Error fetching profile:", err222);
        }
    }

    useEffect(() => {
        getProfile();
    }, []);

    // Update form data when user changes
    useEffect(() => {
        if (user) {
            setFormData({
                fullName: user?.fullName || "",
                mobile: user?.mobile || "",
                email: user?.email || "",
                birthDate: user?.dateBirth
                    ? new Date(user?.dateBirth).toISOString().split("T")[0]
                    : "",
                biography: user?.description || "",
            });

            if (user?.imageId) {
                setProfileImage(user.imageId);
            }
        }
    }, [user]);

    // محاسبه پیشرفت فرم
    useEffect(() => {
        const totalFields = Object.keys(formData).length;
        const filledFields = Object.values(formData).filter(
            (value) => value.trim() !== ""
        ).length;
        const newProgress = Math.round((filledFields / totalFields) * 100);
        setProgress(newProgress);
    }, [formData]);

    // مدیریت تغییر در فیلدهای ورودی
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // اعتبارسنجی شماره موبایل
        if (name === "mobile") {
            // فقط عدد
            let mobile = value.replace(/\D/g, "");

            // نباید با 0 شروع شود
            if (mobile.startsWith("0")) {
                return;
            }

            // بیشتر از 10 رقم نباشد
            if (mobile.length > 10) {
                return;
            }

            setFormData((prev) => ({
                ...prev,
                mobile,
            }));

            return;
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    // مدیریت تاثیرات فوکوس
    const handleInputFocus = (fieldName) => {
        setFocusedField(fieldName);
    };

    const handleInputBlur = () => {
        setFocusedField(null);
    };

    // مدیریت آپلود عکس پروفایل
    const handleProfilePictureClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];

        if (!file || !file.type.startsWith("image/")) return;

        const data = new FormData();
        data.append("file", file);

        try {
            setIsUploadingImage(true);

            const res = await FileService.uploadFile(data);

            console.log("File upload response:", res);

            // خروجی API
            const uploadedImage = res?.data?.message;

            // نمایش فوری عکس
            setProfileImage(uploadedImage);

            // آپدیت user تا اگر جای دیگری هم از user.imageId استفاده شد تغییر کند
            setUser(prev => ({
                ...prev,
                imageId: uploadedImage
            }));
        } catch (error) {
            console.error("File upload error:", error);
        } finally {
            setIsUploadingImage(false);

            // برای اینکه اگر دوباره همان فایل انتخاب شد onChange اجرا شود
            e.target.value = "";
        }
    };

    // Birthdate convertor
    const toMMDDYYYY = (isoDate) => {
        if (!isoDate) return "";
        const [year, month, day] = isoDate.split("-");
        if (!year || !month || !day) return "";
        return `${month}/${day}/${year}`;
    };

    // مدیریت ذخیره فرم
    const handleSaveProfile = async () => {
        setIsSaving(true);
        setSaveSuccess(false);

        const data = {
            fullName: formData?.fullName,
            imageId:
                typeof profileImage === "string"
                    ? profileImage.replace(Url, "")
                    : profileImage?._id,
            email: formData?.email,
            dateBirth: toMMDDYYYY(formData?.birthDate),
            description: formData?.biography,
            mobile: formData?.mobile,
        };

        try {
            const response = await ProfileService.editProfile(data);
            console.log("Server response:", response);
            setIsSaving(false);
            setSaveSuccess(true);
        } catch (error) {
            console.error("Error saving profile:", error);
            setIsSaving(false);
        }

        if (referralCode.trim() !== "") {
            try {
                const res = await LoginService.referralCode({code: referralCode});
                console.log("Referral code response:", res);
            } catch (error) {
                console.error("Error sending referral code:", error);
            }
        }
    };

    //تایید کد دعوت
    const handleSaveReferralCode = async () => {

        setReferralLoading(true);
        try {
            await LoginService.referralCode({code: referralCode});
            setReferralCode(null);
        } catch (error) {
            console.error("Error sending referral code:", error);
        } finally {
            setReferralLoading(false);
        }

    };


    // کلاس مشروط برای فیلدهای فوکوس‌شده
    const getFieldContainerClass = (fieldName) => {
        const baseClass =
            "bg-white rounded-2xl p-4 border border-gray-100 transition-all duration-200";
        return focusedField === fieldName
            ? `${baseClass} ring-2 ring-primary`
            : baseClass;
    };


    return (
        <div dir="ltr" className="bg-gray-50 min-h-screen">
            {/* Header */}
            <header
                dir="rtl"
                className="bg-white pt-6 pb-4 px-5 border-b border-gray-100"
            >
                <div className="flex items-center justify-between">
                    <div className="w-10"></div>
                    <h1 className="text-xl font-bold text-gray-900">Complete Profile</h1>
                    <button
                        onClick={() => Navigate("/profile")}
                        className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
                    >
                        <FaArrowLeft className="text-gray-600"/>
                    </button>
                </div>
            </header>

            {/* Progress Section */}
            <section className="px-5 py-4 bg-white border-b border-gray-100">
                <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-gray-600">
            Profile Completion
          </span>
                    <span className="text-sm font-bold text-primary">{progress}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <div
                        className="bg-gradient-to-r from-primary to-blue-500 h-2 rounded-full transition-all duration-300"
                        style={{width: `${progress}%`}}
                    ></div>
                </div>
            </section>

            {/* Profile Picture Section */}
            <section className="bg-white p-5 border-b border-gray-100">
                <div className="text-center">
                    <div
                        ref={profilePictureRef}
                        onClick={!isUploadingImage ? handleProfilePictureClick : undefined}
                        className={`relative inline-block mb-4 group ${
                            isUploadingImage
                                ? "cursor-not-allowed opacity-80"
                                : "cursor-pointer"
                        }`}
                    >
                        <div
                            className={`relative w-24 h-24 rounded-2xl bg-gray-100 border-2 flex items-center justify-center overflow-hidden transition-all duration-200 ${
                                profileImage
                                    ? "border-solid border-primary"
                                    : "border-dashed border-gray-300"
                            }`}
                        >
                            {profileImage ? (
                                <img
                                    src={
                                        typeof profileImage === "string"
                                            ? `${Url}${profileImage}`
                                            : `${Url}${profileImage?.path}`
                                    }
                                    alt="Profile"
                                    className={`w-full h-full object-cover transition-all duration-300 ${
                                        isUploadingImage ? "opacity-40" : "opacity-100"
                                    }`}
                                />
                            ) : (
                                <FaCamera
                                    className="text-gray-400 text-2xl group-hover:scale-110 transition-transform"
                                />
                            )}

                        </div>
                        <div
                            className="absolute -bottom-2 -left-2 w-8 h-8 bg-primary rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                            {isUploadingImage ? (
                                    <ImSpinner className="text-white text-2xl animate-spin"/>
                                )
                                :
                                <HiPlus className="text-white text-sm"/>
                            }

                        </div>
                    </div>
                    <h3 className="font-semibold text-gray-900 mb-1">
                        Add Profile Picture
                    </h3>
                    <p className="text-sm text-gray-500">
                        Upload a photo to personalize your profile
                    </p>
                </div>

                {/* Hidden File Input */}
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="hidden"
                />
            </section>

            {/* Form Fields Section */}
            <section className="p-5 space-y-4">
                {/* Full Name */}
                <div className={getFieldContainerClass("fullName")}>
                    <label className="text-sm font-medium text-gray-700 mb-2 block">
                        <span className="text-red-500">*</span> Full Name
                    </label>
                    <input
                        // disabled={user?.fullName}
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        onFocus={() => handleInputFocus("fullName")}
                        onBlur={handleInputBlur}
                        placeholder="Enter your full name"
                        className="w-full disabled:bg-gray-200 bg-gray-50 rounded-xl p-3 border border-gray-200 focus:outline-none transition-colors"
                    />
                </div>

                {/*Phone*/}
                <div className={getFieldContainerClass("mobile")}>
                    <label className="text-sm font-medium text-gray-700 mb-2 block">
                        <span className="text-red-500">*</span> Phone Number
                    </label>
                    <input
                        type="tel"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleInputChange}
                        onFocus={() => handleInputFocus("mobile")}
                        onBlur={handleInputBlur}
                        placeholder="9123456789"
                        inputMode="numeric"
                        maxLength={10}
                        className="w-full disabled:bg-gray-200 bg-gray-50 rounded-xl p-3 border border-gray-200 focus:outline-none transition-colors"
                    />
                </div>

                {/* Email */}
                <div className={getFieldContainerClass("email")}>
                    <label className="text-sm font-medium text-gray-700 mb-2 block">
                        <span className="text-red-500">*</span> Email
                    </label>
                    <input
                        type="email"
                        name="email"
                        disabled={user?.email}
                        value={formData.email}
                        onChange={handleInputChange}
                        onFocus={() => handleInputFocus("email")}
                        onBlur={handleInputBlur}
                        placeholder="example@email.com"
                        className="w-full bg-gray-50 rounded-xl p-3 border border-gray-200 focus:outline-none transition-colors"
                    />
                </div>

                {/* Birth Date */}
                <div className={getFieldContainerClass("birthDate")}>
                    <label className="text-sm font-medium text-gray-700 mb-2 block">
                        Date of Birth
                    </label>
                    <input
                        type="date"
                        name="birthDate"
                        value={formData.birthDate}
                        onChange={handleInputChange}
                        onFocus={() => handleInputFocus("birthDate")}
                        onBlur={handleInputBlur}
                        className="w-full bg-gray-50 rounded-xl p-3 border border-gray-200 focus:outline-none transition-colors"
                    />
                </div>

                {/* Biography */}
                <div className={getFieldContainerClass("biography")}>
                    <label className="text-sm font-medium text-gray-700 mb-2 block">
                        Biography (Optional)
                    </label>
                    <textarea
                        name="biography"
                        value={formData.biography}
                        onChange={handleInputChange}
                        onFocus={() => handleInputFocus("biography")}
                        onBlur={handleInputBlur}
                        placeholder="Write about yourself..."
                        rows="3"
                        className="w-full bg-gray-50 rounded-xl p-3 border border-gray-200 focus:outline-none transition-colors resize-none"
                    ></textarea>
                </div>
                {/* <div className="mt-4">
                    <button onClick={() => setReferralOpen(prev => !prev)} className={`w-full text-right border ${referralOpen ? "bg-blue-50 text-blue-600 border-blue-600" : "text-gray-600 border-gray-400"} border-opacity-400 text-sm hover:border-blue-600 hover:text-blue-600 transition-colors duration-300 flex items-center justify-between px-2 py-2 rounded-lg hover:bg-blue-50`} dir="rtl">
                        <span className="font-medium">کد معرف دارید؟</span>
                        <FaAngleDown className={`transition-transform duration-300 ${referralOpen ? "rotate-180" : ""}`} />
                    </button>
                    {referralOpen &&
                        <div className=" overflow-hidden transition-all duration-300">
                            <div className="mt-3 p-4 transition-all duration-300 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
                                <div className="flex items-center gap-2 mb-3">
                                    <BsGiftFill className="text-base" />
                                    <p className="text-xs text-gray-700 font-medium" dir="rtl"> با وارد کردن کد معرف، مبلغ <span className="text-blue-600 font-bold">50,000 تومان</span> هدیه دریافت کنید</p>
                                </div>
                                <input
                                    onChange={(e) => setReferralCode(e.target.value)}
                                    type="text" placeholder="کد معرف را وارد کنید" className="w-full px-4 py-3 bg-white border border-blue-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent text-right text-sm" dir="rtl" />
                            </div>
                        </div>

                    }
                </div> */}

                <div className="bg-gradient-to-br from-primary/10 to-blue-50 rounded-2xl p-4 border border-primary/20">
                    <div className="flex items-start gap-3 mb-3">
                        <div
                            className="w-10 h-10 bg-primary/20 rounded-full flex items-center justify-center flex-shrink-0">
                            <BsGiftFill className="text-primary"/>
                        </div>
                        <div className="flex-1">
                            <h3 className="font-semibold text-gray-900 mb-1">
                                Do you have a referral code?
                            </h3>
                            <p className="text-xs text-gray-600">
                                Enter a referral code and both you and your friend will
                                receive a 50,000 USDT bonus.
                            </p>{" "}
                        </div>
                    </div>
                    <div className={'grid grid-cols-10 gap-4'}>
                        <input
                            onChange={(e) => setReferralCode(e.target.value)}
                            type="text"
                            placeholder="Enter referral code"
                            className="col-span-7 w-full bg-white rounded-xl p-3 border border-primary/30 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-center font-semibold tracking-wider"
                        />
                        <button
                            onClick={handleSaveReferralCode}
                            className={'col-span-3 w-full rounded-xl py-2 px-3 text-white bg-accent disabled:opacity-45'}
                            disabled={referralLoading}
                        >
                            {referralLoading ? "Applying..." : "Apply"}
                        </button>
                    </div>

                </div>
            </section>

            {/* Save Button Section */}
            <section className="p-5 pb-8">
                <button
                    onClick={handleSaveProfile}
                    disabled={isSaving || saveSuccess}
                    className={`w-full text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2 ${
                        saveSuccess
                            ? "bg-green-500"
                            : "bg-primary hover:bg-primary/90 disabled:opacity-75"
                    }`}
                >
                    {isSaving ? (
                        <>
                            <ImSpinner className="animate-spinCustom "/>
                            <span>Saving...</span>
                        </>
                    ) : saveSuccess ? (
                        <>
                            <FaCheck/>
                            <span>Profile Saved!</span>
                        </>
                    ) : (
                        <span>Save Profile</span>
                    )}
                </button>
            </section>

            {/* Bottom Spacing */}
            <div className="h-20"></div>
        </div>
    );
}
